// FacetWP 

// FacetWP filter data to dataLayer
document.addEventListener('facetwp-refresh', function () {
	if (typeof dataLayer !== 'undefined') {
		for (const facetName in FWP.facets) {
			const values = FWP.facets[facetName];
			if (values.length > 0) {
				dataLayer.push({
					event: 'facet_filter_click',
					click_action: facetName,
					click_values: values
				});
			}
		}
	}
});

(function ($) {
	$(document).on('facetwp-loaded', function () {
		$('.no-ajax').off('click');
	});
})(jQuery);